import classNames from "classnames"
import React from "react"

import s from "./Form.module.scss"

export default function Form({ children, className, id, onSubmit }) {
  return (
    <form
      className={classNames(s.form, className)}
      id={id}
      noValidate
      onSubmit={onSubmit}
    >
      {children}
    </form>
  )
}
